// Shared so both the logout path and the idle timer can reach them without
// importing each other.
export const LAST_ACTIVITY_KEY = 'idleLastActivityAt';
export const LOGOUT_SIGNAL_KEY = 'idleLogoutSignal';
export const RESUME_LOCATION_KEY = 'resumeLocationAfterSignIn';
